import { MapPin, Receipt, Scale, MessageCircle, Truck, Headphones, Wifi, Package, Store } from 'lucide-react';

const BASE = 'https://nfcesys.com.br';

export const CITIES = {
  'sao-paulo': {
    slug: 'sistema-pdv-sao-paulo',
    nome: 'São Paulo',
    uf: 'SP',
    icon: MapPin,
    title: 'Sistema PDV em São Paulo com NFC-e SP | Fácil e Barato',
    description: 'Sistema PDV para comércio em São Paulo: NFC-e homologada na SEFAZ-SP, balança, estoque e WhatsApp. Fácil, descomplicado e com o melhor custo-benefício. Atende Brás, Bom Retiro, 25 de Março, Santa Ifigênia e toda a Grande SP. 30 dias grátis.',
    h1b: 'São Paulo',
    sub: 'Do Brás à Santa Ifigênia, do mercadinho da Zona Leste ao restaurante da Paulista: PDV na nuvem com NFC-e homologada na SEFAZ-SP, simples de usar e com preço justo.',
    regioes: ['Brás', 'Bom Retiro', '25 de Março', 'Santa Ifigênia', 'Zona Leste', 'Zona Sul', 'Zona Norte', 'Guarulhos', 'Osasco', 'ABC Paulista'],
    dores: [
      'Ficar sem emitir cupom quando a SEFAZ-SP oscila',
      'Sistema caro que cobra por caixa e por loja',
      'Suporte que não atende no horário do comércio popular',
      'Trocar de sistema e perder o cadastro de produtos',
    ],
    features: [
      { icon: Receipt, t: 'NFC-e SEFAZ-SP', d: 'Emissão homologada em São Paulo com contingência offline automática. Você nunca para de vender.' },
      { icon: Store, t: 'Comércio popular e atacado', d: 'Venda no varejo e no atacado com tabelas de preço diferentes, ideal para Brás e 25 de Março.' },
      { icon: Scale, t: 'Balança integrada', d: 'Toledo, Filizola, Urano e outras — pesagem direta no caixa para mercados e açougues.' },
      { icon: Truck, t: 'iFood, Rappi e Zé Delivery', d: 'Pedidos dos apps de entrega entram e imprimem na cozinha automaticamente.' },
      { icon: MessageCircle, t: 'Vendas no WhatsApp', d: 'Bot com IA que anota pedidos 24h e envia o link do catálogo digital.' },
      { icon: Headphones, t: 'Suporte remoto na hora', d: 'Atendimento humano por WhatsApp e acesso remoto para resolver qualquer coisa sem visita técnica.' },
    ],
    faq: [
      { q: 'O sistema é homologado para NFC-e em São Paulo?', a: 'Sim. Emitimos NFC-e (modelo 65) e NF-e (modelo 55) na SEFAZ-SP em produção e homologação, com certificado digital A1 e CSC.' },
      { q: 'Atendem lojas na Grande São Paulo?', a: 'Sim. Como é 100% na nuvem, atendemos toda a capital, ABC, Guarulhos, Osasco e interior — implantação e suporte são remotos.' },
      { q: 'Consigo migrar meu cadastro de produtos?', a: 'Sim. Importamos por planilha Excel, XML de notas de compra ou direto de bancos Firebird de sistemas antigos.' },
    ],
  },
  'belo-horizonte': {
    slug: 'sistema-pdv-belo-horizonte',
    nome: 'Belo Horizonte',
    uf: 'MG',
    icon: MapPin,
    title: 'Sistema PDV em Belo Horizonte com NFC-e MG | Fácil e Barato',
    description: 'Sistema PDV para comércio em Belo Horizonte: NFC-e homologada na SEFAZ-MG, balança, estoque e WhatsApp. Fácil, descomplicado e com o melhor custo-benefício. Atende Centro, Savassi, Barreiro, Venda Nova, Contagem e Betim. 30 dias grátis.',
    h1b: 'Belo Horizonte',
    sub: 'Do bar da Savassi ao sacolão de Venda Nova: PDV na nuvem com NFC-e homologada na SEFAZ-MG, fácil de usar e com preço que cabe no bolso do comerciante mineiro.',
    regioes: ['Centro', 'Savassi', 'Barreiro', 'Venda Nova', 'Pampulha', 'Contagem', 'Betim', 'Nova Lima', 'Santa Luzia', 'Ribeirão das Neves'],
    dores: [
      'Bar e restaurante sem controle de comanda e cozinha',
      'Sacolão e mercado com balança sem integração',
      'Sistema antigo instalado que trava e perde dados',
      'Mensalidade alta para o tamanho do negócio',
    ],
    features: [
      { icon: Receipt, t: 'NFC-e SEFAZ-MG', d: 'Emissão homologada em Minas Gerais com contingência automática quando a SEFAZ cai.' },
      { icon: Store, t: 'Bares e restaurantes', d: 'Comanda, impressão na cozinha e fechamento por mesa — feito para a cultura de boteco de BH.' },
      { icon: Scale, t: 'Sacolão e mercado', d: 'Balança integrada, etiqueta de peso e estoque por quilo para hortifrúti e açougue.' },
      { icon: Package, t: 'Estoque e compras', d: 'Entrada por XML da nota, alerta de estoque mínimo e produtos próximos do vencimento.' },
      { icon: MessageCircle, t: 'Pedidos no WhatsApp', d: 'Bot com IA anota pedidos e reservas 24h, sem você precisar responder.' },
      { icon: Wifi, t: 'Funciona mesmo offline', d: 'Contingência local garante a venda e a emissão mesmo se a internet oscilar.' },
    ],
    faq: [
      { q: 'É homologado para NFC-e em Minas Gerais?', a: 'Sim. Emitimos NFC-e e NF-e na SEFAZ-MG com certificado A1 e CSC, em homologação e produção.' },
      { q: 'Atendem a região metropolitana de BH?', a: 'Sim. Contagem, Betim, Nova Lima, Santa Luzia e todo o interior de Minas — tudo remoto, sem visita técnica.' },
      { q: 'Serve para bar e restaurante?', a: 'Sim. Comanda por mesa, impressão na cozinha, integração com iFood e cupom fiscal no fechamento.' },
    ],
  },
  curitiba: {
    slug: 'sistema-pdv-curitiba',
    nome: 'Curitiba',
    uf: 'PR',
    icon: MapPin,
    title: 'Sistema PDV em Curitiba com NFC-e PR | Fácil e Barato',
    description: 'Sistema PDV para comércio em Curitiba: NFC-e homologada na SEFAZ-PR, balança, estoque e WhatsApp. Fácil, descomplicado e com o melhor custo-benefício. Atende Centro, Batel, Boqueirão, CIC, São José dos Pinhais e Colombo. 30 dias grátis.',
    h1b: 'Curitiba',
    sub: 'Da padaria do Batel ao mercado do Boqueirão: PDV na nuvem com NFC-e homologada na SEFAZ-PR, simples, rápido de implantar e com o melhor custo-benefício.',
    regioes: ['Centro', 'Batel', 'Boqueirão', 'CIC', 'Portão', 'Sítio Cercado', 'São José dos Pinhais', 'Colombo', 'Pinhais', 'Araucária'],
    dores: [
      'Padaria e mercado com fila no caixa nos horários de pico',
      'Balança e etiqueta de peso sem falar com o sistema',
      'Perder venda quando a internet ou a SEFAZ oscila',
      'Sistemas complexos que exigem treinamento longo',
    ],
    features: [
      { icon: Receipt, t: 'NFC-e SEFAZ-PR', d: 'Emissão homologada no Paraná com contingência automática e reenvio inteligente.' },
      { icon: Scale, t: 'Padarias e mercados', d: 'Balança integrada, produção própria com ficha técnica e etiquetas de peso.' },
      { icon: Store, t: 'Lojas e boutiques', d: 'Grade de tamanho e cor, etiquetas com código de barras e crediário controlado.' },
      { icon: Truck, t: 'Marketplaces', d: 'iFood, Rappi, Shopee, Shein e Mercado Livre centralizados no mesmo sistema.' },
      { icon: MessageCircle, t: 'WhatsApp com IA', d: 'Catálogo digital e bot que vende e anota pedidos 24 horas por dia.' },
      { icon: Headphones, t: 'Implantação em 1 dia', d: 'Cadastre produtos hoje e venda amanhã, com suporte humano acompanhando.' },
    ],
    faq: [
      { q: 'É homologado para NFC-e no Paraná?', a: 'Sim. Emitimos NFC-e e NF-e na SEFAZ-PR com certificado A1 e CSC, em homologação e produção.' },
      { q: 'Atendem a região metropolitana de Curitiba?', a: 'Sim. São José dos Pinhais, Colombo, Pinhais, Araucária e todo o Paraná — implantação e suporte 100% remotos.' },
      { q: 'Preciso comprar equipamento?', a: 'Não. Funciona no computador, notebook ou tablet que você já tem, com qualquer impressora térmica e balança compatível.' },
    ],
  },
};

export const CITY_LIST = Object.entries(CITIES).map(([key, c]) => ({ key, ...c }));
export const cityUrl = (c) => `${BASE}/${c.slug}`;
